import React from "react";
import {
  convertStraight,
  convertThenFormat,
  formatDateTimezon,
} from "../../common-data/Converts";

const PartialDetailsMobile = ({ tableData }) => {
  return (
    <div className="all-leads-log mt30">
      {tableData?.length > 0 &&
        tableData.map((row, index) => {
          return (
            <div className="log-card" key={index}>
              <div className="all-info" style={{ rowGap: "1rem" }}>
                <div className="all-followuo-info-container">
                  <div
                    className="lead-multi-value-cols"
                    style={{
                      padding: "20px",
                    }}
                  >
                    <div className="label-value">
                      <span className="label">Payment Created</span>
                      <span className="value">
                        {row?.payment_created
                          ? formatDateTimezon(row.payment_created)
                          : "-"}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">Schedule Date</span>
                      <span className="value">
                        {row?.date ? convertStraight(row.date) : "-"}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">Amount</span>
                      <span className="value">
                        ₹{convertThenFormat(row?.amount || 0) || 0}
                      </span>
                    </div>

                    <div className="label-value">
                      <span className="label">Status</span>
                      <span
                        className="value"
                        style={{
                          background:
                            row?.status === "pending"
                              ? "#FFEDC0"
                              : row?.status === "completed"
                              ? "#B4E7B9"
                              : "#F3DADA",
                          color:
                            row?.status === "pending"
                              ? "#171717"
                              : row?.status === "completed"
                              ? "#0A701B"
                              : "#D90000",
                          borderRadius: "10px",
                          padding: "10px",
                        }}
                      >
                        {row?.status || "NA"}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default PartialDetailsMobile;
